import React, { useState, useEffect, useRef } from "react";
import useAxios from "../../hooks/useAxios";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";
import { Panel } from "primereact/panel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const MobigapFwd = () => {
  const { user } = useAuth();
  const { response, loading, fetchData } = useAxios();

  const [inputText, setInputText] = useState("");
  const [results, setResults] = useState([]);
  const [lastAction, setLastAction] = useState("");

  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    if (!response) return;
    if (response.status === "success" && response.data) {
      setResults(response.data);
      const successCount = response.data.filter((r) => r.status === "success").length;
      const failCount = response.data.filter((r) => r.status === "error").length;
      toast.current.show({
        severity: failCount === 0 ? "success" : "warn",
        detail: `${lastAction}: ${successCount} успешно, ${failCount} ошибок`,
        life: 5000,
      });
    } else if (response.status === "error") {
      toast.current.show({ severity: "error", detail: response.message, life: 3000 });
    }
  }, [response]);

  const getNumbers = () => {
    return inputText
      .split("\n")
      .map((n) => n.trim())
      .filter((n) => n.length > 0);
  };

  const handleBlock = () => {
    const numbers = getNumbers();
    if (numbers.length === 0) {
      toast.current.show({ severity: "warn", detail: "Введите номера", life: 3000 });
      return;
    }
    confirmDialog({
      message: `Вы уверены, что хотите ЗАБЛОКИРОВАТЬ ${numbers.length} номер(ов)?`,
      header: "Подтверждение блокировки",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Заблокировать",
      rejectLabel: "Отмена",
      accept: () => {
        setLastAction("Блокировка");
        fetchData({ method: "post", url: "/api/mobigap/block", data: { numbers } });
      },
    });
  };

  const handleUnblock = () => {
    const numbers = getNumbers();
    if (numbers.length === 0) {
      toast.current.show({ severity: "warn", detail: "Введите номера", life: 3000 });
      return;
    }
    confirmDialog({
      message: `Вы уверены, что хотите РАЗБЛОКИРОВАТЬ ${numbers.length} номер(ов)?`,
      header: "Подтверждение разблокировки",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-success",
      acceptLabel: "Разблокировать",
      rejectLabel: "Отмена",
      accept: () => {
        setLastAction("Разблокировка");
        fetchData({ method: "post", url: "/api/mobigap/unblock", data: { numbers } });
      },
    });
  };

  const handleCheckStatus = () => {
    const numbers = getNumbers();
    if (numbers.length === 0) {
      toast.current.show({ severity: "warn", detail: "Введите номера", life: 3000 });
      return;
    }
    setLastAction("Проверка");
    fetchData({ method: "post", url: "/api/mobigap/check-status", data: { numbers } });
  };

  const statusBodyTemplate = (rowData) => {
    if (rowData.status === "error") {
      return <Tag severity="danger" value={rowData.message} />;
    }
    return <Tag severity="success" value={rowData.message || rowData.statusText} />;
  };

  if (!user) return null;

  return (
    <div className="flex justify-content-center">
      <div style={{ width: "100%", maxWidth: "900px", padding: "1rem" }}>
        <Toast ref={toast} position="top-right" />
        <ConfirmDialog />

        <Panel header="Блокировка / Разблокировка номеров Mobigap" className="mb-4">
          <div className="p-fluid">
            <label className="block mb-2 font-bold">
              Введите номера (1 строка = 1 номер, формат 992XXXXXXXXX)
            </label>
            <InputTextarea
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              rows={8}
              placeholder={"992XXXXXXXXX\n992XXXXXXXXX\n992XXXXXXXXX"}
              className="mb-3"
            />
            <div className="flex gap-2">
              <Button
                label="Разблокировать"
                icon="pi pi-lock-open"
                severity="success"
                size="small"
                onClick={handleUnblock}
                loading={loading}
              />
              <Button
                label="Заблокировать"
                icon="pi pi-lock"
                severity="warning"
                size="small"
                onClick={handleBlock}
                loading={loading}
              />
              <Button
                label="Проверить"
                icon="pi pi-search"
                severity="info"
                size="small"
                onClick={handleCheckStatus}
                loading={loading}
              />
            </div>
          </div>
        </Panel>

        {loading && <ProgressBar mode="indeterminate" style={{ height: "6px" }} />}

        {results.length > 0 && (
          <DataTable
            ref={dt}
            value={results}
            size="small"
            showGridlines
            stripedRows
            exportFilename="mobigap_operations"
            style={{ fontSize: "0.85rem" }}
          >
            <Column field="msisdn" header="Номер" />
            <Column header="Результат" body={statusBodyTemplate} />
          </DataTable>
        )}
      </div>
    </div>
  );
};

export default MobigapFwd;
